// client/src/components/AnnouncementBanner.jsx
import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { FaInfoCircle, FaExclamationTriangle, FaCheckCircle, FaExclamationCircle, FaBullhorn } from 'react-icons/fa';
import { API_URL } from '../config';
import './AnnouncementBanner.css';

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetchAnnouncement();
  }, []);

  const fetchAnnouncement = async () => {
    try {
      const response = await fetch(`${API_URL}/site-settings`);
      if (response.ok) {
        const data = await response.json();
        const banner = data.announcementBanner;

        // Check if banner is enabled and within date range
        if (banner && banner.enabled) {
          const now = new Date();
          const startDate = banner.startDate ? new Date(banner.startDate) : null;
          const endDate = banner.endDate ? new Date(banner.endDate) : null;

          const isWithinDateRange =
            (!startDate || now >= startDate) &&
            (!endDate || now <= endDate);

          if (isWithinDateRange) {
            // Check if user has dismissed this banner
            const dismissedBanners = JSON.parse(localStorage.getItem('dismissedBanners') || '[]');
            const bannerId = `${banner.message}-${banner.type}`;

            if (!dismissedBanners.includes(bannerId)) {
              setAnnouncement(banner);
            }
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch announcement:', error);
    }
  };

  const handleDismiss = () => {
    if (announcement.dismissible) {
      const bannerId = `${announcement.message}-${announcement.type}`;
      const dismissedBanners = JSON.parse(localStorage.getItem('dismissedBanners') || '[]');
      dismissedBanners.push(bannerId);
      localStorage.setItem('dismissedBanners', JSON.stringify(dismissedBanners));
      setDismissed(true);
    }
  };

  if (!announcement || dismissed) {
    return null;
  }

  const getIcon = () => {
    switch (announcement.type) {
      case 'info':
        return <FaInfoCircle />;
      case 'warning':
        return <FaExclamationTriangle />;
      case 'success':
        return <FaCheckCircle />;
      case 'danger':
        return <FaExclamationCircle />;
      case 'promotion':
        return <FaBullhorn />;
      default:
        return <FaInfoCircle />;
    }
  };

  const content = (
    <div className="announcement-content">
      <span className="announcement-icon">{getIcon()}</span>
      <span className="announcement-message">{announcement.message}</span>
    </div>
  );

  return (
    <Alert
      variant={announcement.type === 'promotion' ? 'primary' : announcement.type}
      className="announcement-banner mb-0"
      dismissible={announcement.dismissible}
      onClose={handleDismiss}
    >
      {announcement.link ? (
        <a href={announcement.link} className="announcement-link" target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      ) : (
        content
      )}
    </Alert>
  );
};

export default AnnouncementBanner;
